/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { RevokedInstallerTokensPage } from '@/pages/InstallerTokens/RevokedInstallerTokensPage';

export function RevokedInstallerTokenRoute() {
  return <RevokedInstallerTokensPage />;
}
